import { Injectable } from '@angular/core';
import { HttpClient, HttpParams  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SharedService } from "../../../shared/services/shared.service";
import { ErrorProcessorService }  from '../../../shared/services/error-processor.service';

import { IMyArtifact } from '../../../interfaces/my-artifact';
import { ITriplet } from '../../interfaces/stats/triplet';
import { IClickThroughChunkResponse } from '../../interfaces/stats/clickthrough-details-chunk-response';
import { IClickthroughSummary } from '../../interfaces/stats/clickthrough-summary';
import { IPrefChangeSummary } from '../../interfaces/stats/pref-change-summary'; 
import { IPrefChangeDetailsChunkResponse } from '../../interfaces/stats/pref-change-details-chunk-response';
import { IIncompleteEnrollmentSummary } from '../../interfaces/stats/incomplete-enrollment-summary';
import { IIncompleteEnrollmentDetailsChunkResponse } from '../../interfaces/stats/incomplete-enrollment-details-chunk-response';

@Injectable({
  providedIn: 'root'
})
export class ClientStatsService {

  protected baseUrl = environment.apiServer.portalUrl;
  
  private readonly clickthroughsTotalCountsUrl = '/clickthroughs/total-cnt';
  private readonly clickthroughsChunkUrl = '/clickthroughs/details-chunk';
  private readonly clickthroughsSummaryUrl = '/clickthroughs/summary';

  private readonly prefChangesTotalCountsUrl = '/pref-changes/total-cnt';
  private readonly prefChangesSummaryUrl = '/pref-changes/summary';
  private readonly prefChangesChunkUrl = '/pref-changes/details-chunk';

  private readonly incompleteEnrollmentsTotalCountsUrl = '/incomplete-enrollments/total-cnt';
  private readonly incompleteEnrollmentsSummaryUrl = '/incomplete-enrollments/summary';
  private readonly incompleteEnrollmentsChunkUrl = '/incomplete-enrollments/details-chunk';

  constructor(
    private readonly http: HttpClient, 
    private readonly sharedService: SharedService,
    private readonly errorProcessorService: ErrorProcessorService) {
   }
 
  // CLICKTHROUGHS
  getClickthroughsTotalCounts(baseUrl: string, brandCode: string, 
      dateFrom: string | undefined, dateTo: string | undefined): Observable<ITriplet> {
    let url = this.getStatsUrl(baseUrl) + this.clickthroughsTotalCountsUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
      console.log('getClickthroughsTotalCounts url', url);
      console.log('getClickthroughsTotalCounts params', params);
      return this.http.get<ITriplet>(url, {params: params, responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
    }

  getClickthroughSummary(baseUrl: string,  brandCode: string, dateFrom: string | undefined, 
      dateTo: string | undefined, aggregationType: string): Observable<IClickthroughSummary[]>{
    let url = this.getStatsUrl(baseUrl) + this.clickthroughsSummaryUrl;
    let dateToNext = this.sharedService.getNextDate(dateTo);
    let params = this.setParams(brandCode, dateFrom, this.sharedService.getFormattedDate(dateToNext));
    params = params.set('aggrType', aggregationType.toUpperCase());
      console.log('getClickthroughsTotalCounts url', url);
      console.log('getClickthroughsTotalCounts params', params);
      return this.http.get<IClickthroughSummary[]>(url,  {params, responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
    } 

  getClickthroughDetails(baseUrl: string, brandCode: string, dateFrom: string | undefined, dateTo: string | undefined, 
      clickthroughId: number, pageSize: number, sortDirection: string, sortField: string): Observable<IClickThroughChunkResponse> {
    let url = this.getStatsUrl(baseUrl) + this.clickthroughsChunkUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
    params = params.set('pageSize', pageSize);
    params = params.set('sortDirection', sortDirection);
    params = params.set('sortField', sortField);
    params = params.set('clickthroughId', clickthroughId);
    console.log('getClickthroughDetails url', url);  
      return this.http.get<IClickThroughChunkResponse>(url, {params: params, responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
    }

  // getClickthroughStats( brandCode: string, dateFrom: string, dateTo: string, aggregationType: string): Observable<IMyArtifact>{
  //   var dateEndPlus1 = this.sharedService.getNextDate(dateTo);
  //     var url = this.baseUrl+ "/artifacts";
  //     var artifactRequest:any = {
  //       artifactName: "ClickThroughs",
  //       artifactParameters :{ 
  //         brandCodes:[brandCode], 
  //         aggrType:aggregationType, 
  //         dateStart:this.sharedService.getFormattedDate(dateFrom), 
  //         dateEnd:this.sharedService.getFormattedDate(dateEndPlus1)
  //       }
  //     }
  //     return this.http.post<IMyArtifact>(url,  artifactRequest , {responseType: 'json'})
  //     .pipe(
  //       catchError(this.errorProcessorService.handleError)
  //     )
  //   } 

  // NOTIFICATION PREFERENCE CHANGES
  getPrefChangesTotalCounts(baseUrl: string, brandCode: string, dateFrom: string | undefined, 
      dateTo: string | undefined): Observable<ITriplet>{
    let url = this.getStatsUrl(baseUrl) + this.prefChangesTotalCountsUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
    console.log('getPrefChangesTotalCounts url', url);
    console.log('getPrefChangesTotalCounts params', params);
    return this.http.get<ITriplet>(url, {params: params, responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  getPrefChangesSummary(baseUrl: string, brandCode: string, dateFrom: string | undefined, 
      dateTo: string | undefined): Observable<IPrefChangeSummary[]>{
    let url = this.getStatsUrl(baseUrl) + this.prefChangesSummaryUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
    console.log('getPrefChangesSummary url', url);
    console.log('getPrefChangesSummary params', params);
    return this.http.get<IPrefChangeSummary[]>(url, {params: params, responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  getPrefChangesDetails(baseUrl: string, brandCode: string, dateFrom: string | undefined, dateTo: string | undefined, 
      prefChangeId: number, pageSize: number, sortDirection: string, sortField: string): Observable<IPrefChangeDetailsChunkResponse> {
console.log('getPrefChangesDetails called with - baseUrl:', baseUrl, 'brandCode:', brandCode, 'dateFrom:', dateFrom, 'dateTo:', dateTo, 'prefChangeId:', prefChangeId, 'pageSize:', pageSize, 'sortDirection:', sortDirection, 'sortField:', sortField);
    let url = this.getStatsUrl(baseUrl) + this.prefChangesChunkUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
    params = params.set('pageSize', pageSize);
    params = params.set('sortDirection', sortDirection);
    params = params.set('sortField', sortField);
    params = params.set('prefChangeId', prefChangeId);
    console.log('getPrefChangesDetails url', url);  
console.log('getPrefChangesDetails params', params);
    return this.http.get<IPrefChangeDetailsChunkResponse>(url, {params: params, responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
    }

  // INCOMPLETE ENROLLMENTS
  getIncompleteEnrollmentsTotalCounts(baseUrl: string, brandCode: string,
      dateFrom: string | undefined, dateTo: string | undefined): Observable<ITriplet> {
    let url = this.getStatsUrl(baseUrl) + this.incompleteEnrollmentsTotalCountsUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
    console.log('getIncompleteEnrollmentsTotalCounts url', url);
    console.log('getIncompleteEnrollmentsTotalCounts params', params);
    return this.http.get<ITriplet>(url, {params: params, responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  getIncompleteEnrollmentsSummary(baseUrl: string, brandCode: string, dateFrom: string | undefined,
      dateTo: string | undefined, aggregationType: string): Observable<IIncompleteEnrollmentSummary[]>{
    let url = this.getStatsUrl(baseUrl) + this.incompleteEnrollmentsSummaryUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
    params = params.set('aggrType', aggregationType.toUpperCase());
    console.log('getIncompleteEnrollmentsSummary url', url);
    console.log('getIncompleteEnrollmentsSummary params', params);
    return this.http.get<IIncompleteEnrollmentSummary[]>(url,  {params, responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  getIncompleteEnrollmentsDetails(baseUrl: string, brandCode: string, dateFrom: string | undefined, dateTo: string | undefined,
      incompleteEnrollmentId: number, pageSize: number, sortDirection: string, sortField: string): Observable<IIncompleteEnrollmentDetailsChunkResponse> {
    let url = this.getStatsUrl(baseUrl) + this.incompleteEnrollmentsChunkUrl;
    let params = this.setParams(brandCode, dateFrom, dateTo);
    params = params.set('pageSize', pageSize);
    params = params.set('sortDirection', sortDirection);
    params = params.set('sortField', sortField);
    params = params.set('incompleteEnrollmentId', incompleteEnrollmentId);
    console.log('getIncompleteEnrollmentsDetails url', url);
    console.log('getIncompleteEnrollmentsDetails params', params);
    return this.http.get<IIncompleteEnrollmentDetailsChunkResponse>(url, {params: params, responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  public getStatsUrl(baseUrl: string) {
      return baseUrl.replaceAll('Walletron','reports') + "/admin/stats";
  }

  private setParams(brandCode: string, dateFrom: string | undefined, dateTo: string | undefined) {
    let params = new HttpParams();
    params = params.set("request-origin", "csr-portal");
    if (brandCode) {
      params = params.set('brandCode', brandCode);
    }
    if (dateFrom) {
      params = params.set('dateFrom', this.sharedService.getFormattedDate(dateFrom));
    }
    if (dateTo) {
      // var dateToNext = this.sharedService.getNextDate(dateTo);
      // params = params.set('dateTo', this.sharedService.getFormattedDate(dateToNext));
      params = params.set('dateTo', this.sharedService.getFormattedDate(dateTo));
    }
    return params;
  }

}
